import {
    SHOW_ESCAPE_HATCH,
    HIDE_ESCAPE_HATCH
} from './EscapeHatchConstants';

export default (state = {
    showEscapeHatch: false
}, action) => {
    switch (action.type) {
        case SHOW_ESCAPE_HATCH:
            return {
                ...state,
                showEscapeHatch: true
            };
        case HIDE_ESCAPE_HATCH:
            return {
                ...state,
                showEscapeHatch: false
            };
        default:
            return state;
    }
};
